import checkFF from '@/lib/feature-flag';

export function isResetOnboardingAPIEnabled(): boolean {
  return checkFF('pwf-3085-handle-reset-status-in-webapp');
}

export function isUnderMaintenance(): boolean {
  return checkFF('pwf-15-use-maintenance-window-for-employee-onboarding');
}

export function shouldEnableTrainingForDocumentTypeSettings(): boolean {
  return checkFF('pwf-3232-enable-training-tag-for-document-type-settings');
}

export function shouldEnableEmployeeOnboardingFlow(): boolean {
  return checkFF('nso-2-69-employee-onboarding-initiation');
}

export function shouldShowExportEmployees(): boolean {
  return checkFF('pwf-1574-enable-onboarding-csv-export');
}

export function shouldEnablePortalAndAdvisorAccess(): boolean {
  return checkFF('pwf-4140-enable-portal-and-advisor-access');
}

export function shouldEnableSignatureDocumentsDeletion(): boolean {
  return checkFF('pwf-4200-enable-signature-documents-delete');
}

export function shouldShowStartDateInInviteScreen(): boolean {
  return checkFF('pwf-4209-capture-employee-start-date-in-invite-screen');
}

export function shouldEnableCapturingBusinessNumberForUSOnboarding(): boolean {
  return checkFF('pwf-4237-enable-capturing-business-number-for-us-onboarding');
}

export function shouldEnableHrBeta(): boolean {
  return checkFF('hire-838-hr-beta');
}

export function shouldEnableHRApp(): boolean {
  return checkFF('pwf-3025-enable-hr-app');
}

export function shouldEnableDocManEmployeeExperience(): boolean {
  return shouldEnableHRApp();
}

export function shouldEnableHrPaywallLogic(): boolean {
  return checkFF('wo-981-deputy-hr-paywall');
}

export function shouldShowFreeOnboardingRemaining(): boolean {
  return checkFF('pwf-806-show-free-onboarding-remaining');
}

export function onboardingButtonABTest(): string {
  return checkFF<string>('pwf-2184-onboarding-button-a-b-testing');
}

export function shouldEnableDocumentLibrary(): boolean {
  return checkFF('pwf-5191-document-library');
}

export function shouldShowAddPeopleButtonForXeroEmbed(): boolean {
  return checkFF('eis-568-add-people-button-for-xero-embed');
}

export function shouldEnableKudos(): boolean {
  return checkFF('pwf-6186-enable-kudos');
}

export function shouldEnableSensitiveData(): boolean {
  return checkFF('pwf-5511-enable-hr-sensitive-data');
}

export function shouldSunsetRequestChangeAndResetOnboarding(): boolean {
  return checkFF('pwf-6134-sunset-request-change-and-reset-onboarding');
}

export function shouldEnableEmployeeDocumentsFromNomono(): boolean {
  return checkFF('pwf-6576-enable-employee-documents-from-nomono');
}

export function shouldEnableMultipartySignature(): boolean {
  return checkFF('pwf-6258-multiparty-signature');
}

export function shouldEnableOnboardingTabActionsFromNomono(): boolean {
  return checkFF('pwf-6877-enable-onboarding-tab-actions-from-nomono');
}

export function shouldEnableRTW(): boolean {
  return checkFF('pwf-6863-rtw-au');
}

export function shouldEnableOngoingRTW(): boolean {
  return checkFF('pwf-7005-rtw-au-m2');
}
